module.exports = __webpack_public_path__ + "img/chat-user4.57893bf4.png";